"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var QueryNameForm = function QueryNameForm(props) {
  var validate = function validate(values) {
    var errors = {};
    if (!values.name) {
      errors.name = 'Name is required';
    }
    return errors;
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    onSubmit: function onSubmit(values) {
      props.onSubmit(values);
      props.closeModal();
    },
    validate: validate,
    render: function render(_ref) {
      var handleSubmit = _ref.handleSubmit;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "name",
        component: _cccisdFormik.CccisdInput,
        label: "Name"
      }), /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary",
        type: "submit",
        onClick: handleSubmit
      }, "Submit"));
    }
  }));
};
QueryNameForm.propTypes = {
  onSubmit: _propTypes["default"].func,
  closeModal: _propTypes["default"].func
};
var _default = QueryNameForm;
exports["default"] = _default;